import React from 'react'

import downloadAppQrcodeIcon from '@assets/download-app-qrcode.svg'
import { Cellphone } from '@components/common/Cellphone'
import { Heading } from '@fourthwall/components'
import { MOBILE_APP_ANDROID_LINK, MOBILE_APP_IOS_LINK } from '@fourthwall/utils/dist/links'

import * as S from './NoThankYousContent.styled'

export const NoThankYousContent = () => (
  <S.Container>
    <S.CellphoneWrapper>
      <Cellphone />
    </S.CellphoneWrapper>
    <S.InfoWrapper>
      <S.Message>
        <Heading type="h6" asTag="h2" weight="semibold">
          You haven’t sent any thank yous yet
        </Heading>
        <S.Subtitle>Download our app to send personal thank yous to your fans!</S.Subtitle>
      </S.Message>
      <S.DownloadAppIcons>
        <S.DownloadAppQrcodeIcon src={downloadAppQrcodeIcon} alt="Download app" />
        <S.DownloadLink
          href={MOBILE_APP_IOS_LINK}
          target="_blank"
          aria-label="Download Application from App Store"
        >
          <S.AppDownloadAppStore />
        </S.DownloadLink>
        <S.DownloadLink
          href={MOBILE_APP_ANDROID_LINK}
          target="_blank"
          aria-label="Download Application from Google Play"
        >
          <S.AppDownloadGooglePlay />
        </S.DownloadLink>
      </S.DownloadAppIcons>
    </S.InfoWrapper>
  </S.Container>
)
